import React from 'react'
import { SetItemsFilter, } from '../ManageSetsComponents'
import forOwn from 'mout/object/forOwn'

/*
  <SetItemsFilterRow
    filters={props.filters}
    removeItemFilter={props.removeItemFilter}
  />
*/

export default function SetItemsFilterRow(props) {

  let setItemsFilters = []
  forOwn(props.filters, (val, key, o) => {
    if (val) {
      setItemsFilters.push(
        <SetItemsFilter 
          filterBy={key} 
          filterText={val} 
          key={`appliedFilter${key}`}
          removeItemFilter={props.removeItemFilter}
        />
      )
    }
  })
  if (setItemsFilters === []) {
    setItemsFilters = <div></div>
  }

  return (
    <div>
      {setItemsFilters}
    </div>    
  )
}




// WEBPACK FOOTER //
// ./src/components/Content/ManageSetsComponents/SetItemsFilterRow.js